import { ref, computed } from "vue";
import { useStoreCompat } from "./index";
import { useDependenciasStore } from "@/store/Pinia/useDependenciasStore";

export function useFiltersDetenidos() {
  const filterDropdown = ref({});
  const store = useStoreCompat();
  const dependenciasStore = useDependenciasStore();
  const usuario = ref(store.state.user);
  const userDependencia = usuario.value.userdata.dependenciaID;
  const isSuperAdmin = usuario.value.userdata.tipoUsuario === "Super User";

  // Cargar dependencias al inicializar
  if (isSuperAdmin) {
    dependenciasStore.setDependencias();
  }

  const filtersFields = computed(() => {
    const baseFilters = [
      {
        name: "DNI",
        field: "exp_pre_PersonaFisica.NumeroIdentificacion",
        type: "text",
        queryType: "search",
        operator: "=",
      },
      {
        name: "Número de Actuación",
        field: "NumeroActuacion",
        type: "text",
        queryType: "direct",
      },
      {
        name: "UFI",
        field: "Ufi",
        type: "text",
        queryType: "direct",
      },
      {
        name: "Juzgado",
        field: "Juzgado",
        type: "text",
        queryType: "direct",
      },
      {
        name: "Fecha",
        field: "fecha",
        type: "date",
        queryType: "date",
        dateFieldOptions: [
          { name: "Fecha de Ingreso", value: "exp_pre_CalabozoDetencion.FechaCreacion" },
          { name: "Fecha de Egreso", value: "exp_pre_CalabozoDetencion.FechaHoraEgreso" },
        ],
      },
    ];

    // Agregar filtro de Dependencia solo si es SuperAdmin
    if (isSuperAdmin) {
      baseFilters.push({
        name: "Dependencia",
        field: "exp_pre_CalabozoDetencion.DependenciaID",
        type: "dropdown",
        queryType: "search",
        operator: "=",
        dependenciaOptions: dependenciasStore.dependencias || [],
      });
    }

    return baseFilters;
  });

  const orderedDropdown = () => {
    return Object.keys(filterDropdown.value)
      .sort()
      .reduce((acc, key) => {
        acc[key] = filterDropdown.value[key];
        return acc;
      }, {});
  };

  return {
    filterDropdown,
    filtersFields,
    orderedDropdown,
    userDependencia,
    isSuperAdmin,
  };
}
